import { render, staticRenderFns } from "./CCSlashes.vue?vue&type=template&id=5a9e44a8&"
import script from "./CCSlashes.vue?vue&type=script&lang=ts&"
export * from "./CCSlashes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports